module.exports = __webpack_public_path__ + "img/EMT-BRCA_10X_Section1.3b07f512.png";